/* ============================================================
   LE CADRAN — theme.js
   Sepet, katmanlar (drawer/arama/menu), wishlist, urun galerisi,
   filtreler, scroll animasyonlari ve video yonetimi.
   ============================================================ */
(function () {
  'use strict';

  var routes = (window.theme && window.theme.routes) || {};
  var body = document.body;

  /* ------------------------------------------------------------
     PARA FORMATI
     ------------------------------------------------------------ */
  function formatMoney(cents, format) {
    format = format || (window.theme && window.theme.moneyFormat) || '${{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var amount = cents / 100.0;

    function fmt(num, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(num) || num == null) return 0;
      num = (num / 1).toFixed(precision);
      var parts = num.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var frac = parts[1] ? decimal + parts[1] : '';
      return whole + frac;
    }

    var match = format.match(placeholderRegex);
    if (!match) return format;

    switch (match[1]) {
      case 'amount': value = fmt(amount, 2); break;
      case 'amount_no_decimals': value = fmt(amount, 0); break;
      case 'amount_with_comma_separator': value = fmt(amount, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(amount, 0, '.', ','); break;
      case 'amount_with_space_separator': value = fmt(amount, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(amount, 0, ' '); break;
    }
    return format.replace(placeholderRegex, value);
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /* ------------------------------------------------------------
     KATMAN YONETIMI — sepet, arama, mobil menu tek elden
     ------------------------------------------------------------ */
  var overlay = document.getElementById('Overlay');
  var cartDrawer = document.getElementById('CartDrawer');
  var mobileMenu = document.getElementById('MobileMenu');

  function closeLayers() {
    if (overlay) overlay.classList.remove('is-open');
    [cartDrawer, mobileMenu].forEach(function (el) {
      if (!el) return;
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('[data-menu-open]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
    body.classList.remove('locked');
  }

  function openLayer(el, useOverlay) {
    if (!el) return;
    closeLayers();
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    if (useOverlay && overlay) overlay.classList.add('is-open');
    body.classList.add('locked');
  }

  function openCart() { openLayer(cartDrawer, true); }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) {
      e.preventDefault();
      fetchCart().then(openCart);
    } else if (e.target.closest('[data-cart-close]')) {
      closeLayers();
    } else if (e.target.closest('[data-menu-open]')) {
      e.preventDefault();
      openLayer(mobileMenu, false);
      e.target.closest('[data-menu-open]').setAttribute('aria-expanded', 'true');
    } else if (e.target.closest('[data-menu-close]')) {
      closeLayers();
    } else if (e.target.closest('[data-close-layers]')) {
      closeLayers();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeLayers();
  });

  document.querySelectorAll('.mobile-menu__links a').forEach(function (a) {
    a.addEventListener('click', closeLayers);
  });

  /* ------------------------------------------------------------
     SEPET API
     ------------------------------------------------------------ */
  var cartItemsEl = document.getElementById('CartItems');
  var cartEmptyEl = document.getElementById('CartEmpty');
  var cartTotalEl = document.getElementById('CartTotal');
  var cartCountEl = document.getElementById('CartCount');
  var cartCheckoutBtn = document.getElementById('CartCheckout');
  var cartClearWrap = document.getElementById('CartClearWrap');

  function fetchCart() {
    return fetch(routes.cart ? routes.cart + '.js' : '/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; })
      .catch(function () { return null; });
  }

  function addToCart(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Add to cart failed');
        return r.json();
      })
      .then(fetchCart)
      .then(function (cart) { openCart(); return cart; });
  }

  function changeCart(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  var ICON_CLOSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><path d="m5 5 14 14M19 5 5 19"/></svg>';

  /* ------------------------------------------------------------
     UCRETSIZ KARGO CUBUGU
     Esik TL cinsinden ayardan gelir; sepet tutari kurus cinsinden
     geldigi icin 100 ile carpilir.
     ------------------------------------------------------------ */
  function renderShipBars(cart) {
    var bars = document.querySelectorAll('[data-ship-bar]');
    if (!bars.length || !cart) return;

    Array.prototype.forEach.call(bars, function (bar) {
      var esikTL = parseFloat(bar.getAttribute('data-threshold')) || 0;
      if (esikTL <= 0) { bar.hidden = true; return; }

      var esik = esikTL * 100;
      // Indirim sonrasi odenecek tutar uzerinden — kargo da onun uzerinden hesaplanir
      var tutar = cart.total_price || 0;
      var kalan = esik - tutar;
      var oran = Math.max(0, Math.min(100, (tutar / esik) * 100));

      var text = bar.querySelector('[data-ship-text]');
      var fill = bar.querySelector('[data-ship-fill]');

      // Sepet bossa cubuk gosterilmez
      if (!cart.item_count) { bar.hidden = true; return; }
      bar.hidden = false;

      if (kalan <= 0) {
        bar.classList.add('is-complete');
        if (text) text.innerHTML = '<strong>Kargo bedava!</strong> Ücretsiz gönderim hakkını kazandın.';
      } else {
        bar.classList.remove('is-complete');
        if (text) {
          text.innerHTML = 'Ücretsiz kargoya <strong>' + formatMoney(kalan) + '</strong> kaldı.';
        }
      }
      if (fill) fill.style.width = oran + '%';
    });
  }

  function renderCart(cart) {
    if (!cart) return;

    if (cartCountEl) {
      cartCountEl.textContent = cart.item_count;
      cartCountEl.hidden = cart.item_count === 0;
    }
    if (cartTotalEl) cartTotalEl.textContent = formatMoney(cart.total_price);
    renderShipBars(cart);
    if (!cartItemsEl) return;

    if (cart.item_count === 0) {
      cartItemsEl.innerHTML = '';
      if (cartEmptyEl) cartItemsEl.appendChild(cartEmptyEl);
      if (cartCheckoutBtn) cartCheckoutBtn.disabled = true;
      if (cartClearWrap) cartClearWrap.style.display = 'none';
      return;
    }

    if (cartCheckoutBtn) cartCheckoutBtn.disabled = false;
    if (cartClearWrap) cartClearWrap.style.display = 'flex';

    cartItemsEl.innerHTML = cart.items.map(function (item, i) {
      var line = i + 1;
      var title = escapeHtml(item.product_title);
      var img = item.image
        ? '<a href="' + escapeHtml(item.url) + '"><img src="' + escapeHtml(item.image) + '&width=200" alt="' + title + '" width="86" height="104" loading="lazy"></a>'
        : '<span></span>';
      var variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<p class="cart-line__variant">' + escapeHtml(item.variant_title) + '</p>'
        : '';

      /*
        Indirim seffafligi: Shopify otomatik indirim uygularsa fiyat
        sepette dusuk gorunur. Sebebini yazmazsak musteri "fiyat neden
        degisti?" diye tereddut ediyor — indirimi acikca gosteriyoruz.
      */
      var discounted = item.original_line_price > item.final_line_price;
      var priceHtml = discounted
        ? '<s>' + formatMoney(item.original_line_price) + '</s> ' + formatMoney(item.final_line_price)
        : formatMoney(item.final_line_price);

      var discountHtml = '';
      var allocs = item.line_level_discount_allocations || [];
      if (allocs.length) {
        discountHtml = allocs.map(function (a) {
          var title = (a.discount_application && a.discount_application.title) || 'İndirim';
          return '<p class="cart-line__discount">' + escapeHtml(title) +
                 ' &minus;' + formatMoney(a.amount) + '</p>';
        }).join('');
      }

      return '' +
        '<div class="cart-line">' +
        img +
        '  <div>' +
        '    <h3 class="cart-line__title"><a href="' + escapeHtml(item.url) + '">' + title + '</a></h3>' +
        variant +
        '    <div class="cart-line__price">' + priceHtml + '</div>' +
        discountHtml +
        '    <div class="cart-line__qty">' +
        '      <button type="button" data-cart-decrease data-line="' + line + '" aria-label="Azalt">&minus;</button>' +
        '      <span data-line-qty="' + line + '">' + item.quantity + '</span>' +
        '      <button type="button" data-cart-increase data-line="' + line + '" aria-label="Arttır">+</button>' +
        '    </div>' +
        '  </div>' +
        '  <button type="button" class="cart-line__remove" data-cart-remove data-line="' + line + '" aria-label="Ürünü kaldır">' + ICON_CLOSE + '</button>' +
        '</div>';
    }).join('');
  }

  /* Sepet satiri islemleri — delegasyon (yeniden render'a dayanikli) */
  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-cart-remove]');
    var decBtn = e.target.closest('[data-cart-decrease]');
    var incBtn = e.target.closest('[data-cart-increase]');

    if (removeBtn) {
      changeCart(parseInt(removeBtn.getAttribute('data-line'), 10), 0);
      return;
    }
    if (decBtn || incBtn) {
      var btn = decBtn || incBtn;
      var line = parseInt(btn.getAttribute('data-line'), 10);
      var qtyEl = document.querySelector('[data-line-qty="' + line + '"]');
      var current = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      changeCart(line, decBtn ? Math.max(0, current - 1) : current + 1);
    }
  });

  /* Sepeti bosalt */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-cart-clear]')) return;
    if (!confirm('Sepetinizdeki tüm ürünler kaldırılacak. Emin misiniz?')) return;
    fetch('/cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  });

  /* Sepete ekle butonlari (urun kartlari) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;
    e.preventDefault();

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var original = btn.innerHTML;
    btn.disabled = true;
    btn.textContent = 'Ekleniyor…';

    addToCart(variantId, 1)
      .then(function () { btn.disabled = false; btn.innerHTML = original; })
      .catch(function () {
        btn.disabled = false;
        btn.innerHTML = original;
        alert('Ürün eklenemedi. Lütfen tekrar deneyin.');
      });
  });

  /* Hemen al — sepete ekle + odemeye yonlendir */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-buy-now]');
    if (!btn) return;
    e.preventDefault();

    var form = document.querySelector('[data-product-form]');
    var variantId = btn.getAttribute('data-variant-id');
    var qtyEl = document.getElementById('Quantity');
    var qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;

    var payload;
    if (form) {
      payload = new FormData(form);
    } else if (variantId) {
      payload = new FormData();
      payload.append('id', variantId);
      payload.append('quantity', qty);
    } else {
      return;
    }

    var original = btn.innerHTML;
    btn.disabled = true;
    btn.textContent = 'Yönlendiriliyor…';

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      body: payload
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Add failed');
        return r.json();
      })
      .then(function () { window.location.href = '/checkout'; })
      .catch(function () {
        btn.disabled = false;
        btn.innerHTML = original;
        alert('Şu an satın alma başlatılamadı. Stok kontrol edin ya da tekrar deneyin.');
      });
  });

  /* Urun sayfasi formu */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = form.querySelector('button[type="submit"]');
      var original = submitBtn ? submitBtn.innerHTML : '';
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Ekleniyor…'; }

      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) {
          if (!r.ok) throw new Error('Add failed');
          return r.json();
        })
        .then(fetchCart)
        .then(function () {
          openCart();
          if (submitBtn) { submitBtn.disabled = false; submitBtn.innerHTML = original; }
        })
        .catch(function () {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.innerHTML = original; }
          alert('Sepete eklenemedi. Stok kontrol edin.');
        });
    });
  });

  if (cartDrawer) fetchCart();

  /* ------------------------------------------------------------
     WISHLIST (localStorage)
     ------------------------------------------------------------ */
  var WISHLIST_KEY = 'lecadran_wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); }
    catch (e) { return []; }
  }
  function saveWishlist(list) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function updateWishlistCount() {
    var count = getWishlist().length;
    var counter = document.getElementById('WishlistCount');
    if (!counter) return;
    counter.textContent = count;
    counter.hidden = count === 0;
  }
  function markWishlistButtons() {
    var list = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      btn.classList.toggle('is-active', list.indexOf(btn.getAttribute('data-product-handle')) > -1);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var handle = btn.getAttribute('data-product-handle');
    if (!handle) return;

    var list = getWishlist();
    var idx = list.indexOf(handle);
    if (idx > -1) list.splice(idx, 1); else list.push(handle);

    saveWishlist(list);
    updateWishlistCount();
    markWishlistButtons();
  });

  updateWishlistCount();
  markWishlistButtons();

  /* ------------------------------------------------------------
     URUN FILTRELERI (anasayfa koleksiyon bolumu)
     ------------------------------------------------------------ */
  var filterButtons = document.querySelectorAll('.filter[data-filter]');
  if (filterButtons.length) {
    filterButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var value = btn.getAttribute('data-filter');

        filterButtons.forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });

        document.querySelectorAll('[data-product-grid] .product-card').forEach(function (card) {
          var cardValue = card.getAttribute('data-filter-value');
          card.hidden = value !== 'all' && cardValue !== value;
        });
      });
    });
  }

  /* ------------------------------------------------------------
     ONGORULU ARAMA (Shopify predictive search)
     ------------------------------------------------------------ */
  var searchInput = document.querySelector('[data-predictive-search]');
  var searchResults = document.getElementById('SearchResults');

  if (searchInput && searchResults) {
    var searchTimer = null;

    function hideResults() { searchResults.hidden = true; searchResults.innerHTML = ''; }

    // Disari tiklayinca kapan
    document.addEventListener('click', function (e) {
      if (!searchResults.contains(e.target) && e.target !== searchInput) hideResults();
    });
    searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { hideResults(); searchInput.blur(); }
    });

    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim();
      clearTimeout(searchTimer);

      if (q.length < 2) { hideResults(); return; }

      searchTimer = setTimeout(function () {
        searchResults.hidden = false;
        searchResults.innerHTML = '<div class="header__search-results__msg">Aranıyor…</div>';

        fetch('/search/suggest.json?q=' + encodeURIComponent(q) +
              '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last',
              { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];

            if (!products.length) {
              searchResults.innerHTML = '<div class="header__search-results__msg">Eşleşen ürün bulunamadı.</div>';
              return;
            }

            searchResults.innerHTML =
              '<div class="search-results__list">' +
              products.map(function (p) {
                var img = p.featured_image && p.featured_image.url
                  ? '<img src="' + escapeHtml(p.featured_image.url) + '&width=120" alt="" width="44" height="54" loading="lazy">'
                  : '';
                return '<a class="search-results__item" href="' + escapeHtml(p.url) + '">' +
                  img +
                  '<span><strong>' + escapeHtml(p.title) + '</strong>' +
                  '<span>' + (p.price ? formatMoney(p.price) : '') + '</span></span>' +
                  '</a>';
              }).join('') +
              '</div>';
          })
          .catch(function () {
            searchResults.innerHTML = '<div class="header__search-results__msg">Arama şu an kullanılamıyor.</div>';
          });
      }, 250);
    });
  }

  /* ------------------------------------------------------------
     SCROLL ANIMASYONLARI
     ------------------------------------------------------------ */
  var revealTargets = document.querySelectorAll('[data-reveal]');
  if (revealTargets.length && 'IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    revealTargets.forEach(function (el) { revealObserver.observe(el); });
  } else {
    revealTargets.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* Atolye asamalarinin alt cizgisi */
  var stages = document.querySelectorAll('[data-stage]');
  if (stages.length && 'IntersectionObserver' in window) {
    var stageObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) entry.target.classList.add('is-visible');
      });
    }, { threshold: 0.4 });
    stages.forEach(function (el) { stageObserver.observe(el); });
  }

  /* ------------------------------------------------------------
     VIDEO — sadece ekrandayken oynat (pil ve veri tasarrufu)
     ------------------------------------------------------------ */
  var videoCards = document.querySelectorAll('.bento__card, .hero');
  if (videoCards.length && 'IntersectionObserver' in window) {
    var videoObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target.querySelector('video');
        if (!video) return;
        if (entry.isIntersecting) {
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.3 });

    videoCards.forEach(function (el) {
      if (el.querySelector('video')) videoObserver.observe(el);
    });
  }

  /* ------------------------------------------------------------
     URUN SAYFASI — adet arttir/azalt
     ------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var up = e.target.closest('[data-qty-up]');
    var down = e.target.closest('[data-qty-down]');
    if (!up && !down) return;

    var input = document.getElementById('Quantity');
    if (!input) return;

    var val = parseInt(input.value, 10) || 1;
    var min = parseInt(input.min, 10) || 1;
    var max = parseInt(input.max, 10) || 99;

    input.value = up ? Math.min(max, val + 1) : Math.max(min, val - 1);
  });

  /* ------------------------------------------------------------
     URUN SAYFASI — VARYANT SECIMI

     Secim degistiginde su dordu birden guncellenir:
       1. form'daki gizli "id" alani  -> sepete DOGRU varyant gider
       2. fiyat blogu                 -> sunucuda basilmis sloglar arasi gecis
       3. sepete ekle butonu          -> stok durumu
       4. galeri                      -> varyantin kendi gorseli

     Fiyat JS'te HESAPLANMAZ. Her varyantin fiyat blogu sunucuda
     basilip gizleniyor; burada sadece hangisinin gorunecegi
     degisiyor. Boylece indirim ve "en dusuk fiyat" mantigi tek
     yerde kaliyor ve iki yerde birbirinden sapamiyor.
     ------------------------------------------------------------ */
  (function () {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;

    var veriEl = document.querySelector('[data-variant-json]');
    if (!veriEl) return;                       // tek varyantli urun

    var varyantlar;
    try { varyantlar = JSON.parse(veriEl.textContent); }
    catch (e) { return; }                      // bozuk veri -> sunucu hali kalsin
    if (!varyantlar || !varyantlar.length) return;

    var gizliId  = form.querySelector('input[name="id"]');
    var ekleBtn  = form.querySelector('button[type="submit"]');
    var slotlar  = document.querySelectorAll('[data-variant-price]');
    var gruplar  = form.querySelectorAll('.pdp__option');
    var stickyBtn = document.querySelector('[data-sticky-submit]');

    function seciliDegerler() {
      return Array.prototype.map.call(gruplar, function (g) {
        var r = g.querySelector('input:checked');
        return r ? r.value : null;
      });
    }

    function varyantBul(degerler) {
      for (var i = 0; i < varyantlar.length; i++) {
        var v = varyantlar[i], uyar = true;
        for (var j = 0; j < degerler.length; j++) {
          if (degerler[j] === null) continue;
          if (v.options[j] !== degerler[j]) { uyar = false; break; }
        }
        if (uyar) return v;
      }
      return null;
    }

    /* Bir secenek degeri, DIGER seciliyken hic stokta degilse
       ustu cizilir. Tiklanabilir kalir — musteri neyin tukendigini
       gormeli, secenek sessizce kaybolmamali. */
    function stoklariIsaretle() {
      var mevcut = seciliDegerler();
      gruplar.forEach(function (g, gi) {
        g.querySelectorAll('.pdp__swatch').forEach(function (lab) {
          var inp = lab.querySelector('input');
          if (!inp) return;
          var deneme = mevcut.slice();
          deneme[gi] = inp.value;
          var v = varyantBul(deneme);
          lab.classList.toggle('is-yok', !v || !v.available);
        });
      });
    }

    function gorseliGetir(v) {
      if (!v || v.image_id === null || v.image_id === undefined) return;
      var thumb = document.querySelector('[data-thumb][data-image-id="' + v.image_id + '"]');
      if (thumb && !thumb.classList.contains('is-active')) thumb.click();
    }

    function uygula() {
      var v = varyantBul(seciliDegerler());

      // Secilen kombinasyonun karsiligi yoksa satisi ac birakma
      if (!v) {
        if (ekleBtn) {
          ekleBtn.disabled = true;
          ekleBtn.textContent = 'Bu seçim mevcut değil';
        }
        stoklariIsaretle();
        return;
      }

      if (gizliId) gizliId.value = v.id;

      slotlar.forEach(function (s) {
        s.hidden = String(s.getAttribute('data-variant-price')) !== String(v.id);
      });

      if (ekleBtn) {
        ekleBtn.disabled = !v.available;
        ekleBtn.textContent = v.available
          ? (ekleBtn.getAttribute('data-label-add') || 'Sepete Ekle')
          : (ekleBtn.getAttribute('data-label-sold') || 'Tükendi');
      }

      if (stickyBtn) stickyBtn.setAttribute('data-variant-id', v.id);

      // Secili degerin adini basligin yaninda goster
      gruplar.forEach(function (g) {
        var r = g.querySelector('input:checked');
        var et = g.querySelector('[data-option-selected]');
        if (r && et) et.textContent = r.value;
      });

      gorseliGetir(v);
      stoklariIsaretle();

      // Adres cubugu: sayfa yenilenmeden paylasilabilir kalsin
      try {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState({}, '', u.toString());
      } catch (e) {}
    }

    form.addEventListener('change', function (e) {
      if (e.target && e.target.type === 'radio') uygula();
    });

    stoklariIsaretle();
  })();

  /* ------------------------------------------------------------
     URUN SAYFASI — sabit sepet cubugu
     ------------------------------------------------------------ */
  var stickyBar = document.getElementById('StickyAddToCart');
  var productForm = document.querySelector('[data-product-form]');

  if (stickyBar && productForm) {
    var addBtn = productForm.querySelector('button[type="submit"]') || productForm;

    /* v142: eskiden IntersectionObserver kullaniliyordu ve canli
       testte hic tetiklenmedi — cubuk sayfanin hicbir yerinde
       gorunmuyordu. Dogrudan kaydirma dinleyicisine cevrildi:
       daha ongorulebilir, her tarayicida ayni calisir. */
    var stickyKontrol = function () {
      var alt = addBtn.getBoundingClientRect().bottom;
      stickyBar.classList.toggle('is-visible', alt < 0);
    };

    var bekliyor = false;
    var stickyTetik = function () {
      if (bekliyor) return;
      bekliyor = true;
      window.requestAnimationFrame(function () { bekliyor = false; stickyKontrol(); });
    };

    window.addEventListener('scroll', stickyTetik, { passive: true });
    window.addEventListener('resize', stickyTetik, { passive: true });
    stickyKontrol();

    var stickyBtn = stickyBar.querySelector('[data-sticky-submit]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (productForm.requestSubmit) productForm.requestSubmit();
        else productForm.submit();
      });
    }
  }

  /* ------------------------------------------------------------
     URUN GALERISI — thumbnail, oklar, klavye, hover zoom
     ------------------------------------------------------------ */
  var gallery = document.getElementById('PDPGallery');
  if (gallery) {
    var viewport = document.getElementById('PDPGalleryViewport');
    var mainImg = document.getElementById('MainProductImage');
    var mainVideo = document.getElementById('MainProductVideo');
    var indexEl = document.getElementById('PDPGalleryIndex');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-thumb]'));
    var current = 0;

    function setActive(idx) {
      if (!thumbs.length) return;
      if (idx < 0) idx = thumbs.length - 1;
      if (idx >= thumbs.length) idx = 0;
      current = idx;

      var src = thumbs[idx].getAttribute('data-img');
      var vsrc = thumbs[idx].getAttribute('data-video');

      // Video medyasi: gorselin yerine video oynatilir (sessiz, dongulu).
      if (mainVideo) {
        if (vsrc) {
          if (mainVideo.getAttribute('src') !== vsrc) mainVideo.setAttribute('src', vsrc);
          mainVideo.hidden = false;
          if (mainImg) mainImg.hidden = true;
          viewport.classList.add('is-video');
          var oynat = mainVideo.play();
          if (oynat && oynat.catch) oynat.catch(function () {});
        } else {
          mainVideo.pause();
          mainVideo.hidden = true;
          if (mainImg) mainImg.hidden = false;
          viewport.classList.remove('is-video');
        }
      }

      if (!vsrc && mainImg && src) {
        mainImg.src = src;
        var alt = thumbs[idx].getAttribute('data-alt');
        if (alt) mainImg.alt = alt;
      }

      thumbs.forEach(function (tb, i) { tb.classList.toggle('is-active', i === idx); });
      if (indexEl) indexEl.textContent = idx + 1;
    }

    // Serit surukleniyorsa tiklama yutulur — asagida drag kodu ayarlar
    var dragSuppressClick = false;

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        if (dragSuppressClick) return;
        setActive(i);
      });
    });

    var prevBtn = gallery.querySelector('[data-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-gallery-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { setActive(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { setActive(current + 1); });

    // v104: telefonda ana gorselde parmakla sola/saga kaydirma
    if (viewport) {
      // v112: Iki parmakla yakinlastirirken parmaklardan biri yana
      // kaydigi icin kaydirma sayiliyor ve gorsel degisiyordu. Coklu
      // dokunus basladigi anda kaydirma iptal edilir.
      var sx = 0, sy = 0, coklu = false;
      viewport.addEventListener('touchstart', function (e) {
        if (e.touches.length > 1) { coklu = true; return; }
        coklu = false;
        sx = e.touches[0].clientX; sy = e.touches[0].clientY;
      }, { passive: true });
      viewport.addEventListener('touchmove', function (e) {
        if (e.touches.length > 1) coklu = true;
      }, { passive: true });
      viewport.addEventListener('touchend', function (e) {
        if (coklu) { if (e.touches.length === 0) coklu = false; return; }
        var dx = e.changedTouches[0].clientX - sx;
        var dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) {
          setActive(current + (dx < 0 ? 1 : -1));
        }
      }, { passive: true });
    }

    document.addEventListener('keydown', function (e) {
      var tag = (document.activeElement && document.activeElement.tagName) || '';
      if (tag === 'INPUT' || tag === 'TEXTAREA') return;
      if (e.key === 'ArrowLeft') setActive(current - 1);
      if (e.key === 'ArrowRight') setActive(current + 1);
    });

    /* Imlecle buyutme (hover zoom) kaldirildi — sakin, gosterissiz galeri. */

    /* --------------------------------------------------------
       Kucuk resim seridi: oklar, fare ile surukleme, dokunmatik
       -------------------------------------------------------- */
    var track = gallery.querySelector('[data-thumbs-track]');
    var prevThumbs = gallery.querySelector('[data-thumbs-prev]');
    var nextThumbs = gallery.querySelector('[data-thumbs-next]');

    if (track) {
      function updateThumbArrows() {
        // Serit tasmiyorsa oklara gerek yok
        var overflow = track.scrollWidth - track.clientWidth;
        var show = overflow > 4;
        if (prevThumbs) prevThumbs.hidden = !show || track.scrollLeft <= 2;
        if (nextThumbs) nextThumbs.hidden = !show || track.scrollLeft >= overflow - 2;
      }

      function scrollThumbs(dir) {
        // Tam kucuk resim adimiyla kaydir — yarim resimde kalmasin
        var first = track.querySelector('.pdp__thumb');
        var pitch = 80; // varsayilan: 72px genislik + 8px bosluk
        if (first) {
          var gap = parseFloat(getComputedStyle(track).columnGap) || 8;
          pitch = first.getBoundingClientRect().width + gap;
        }
        var perStep = Math.max(Math.floor((track.clientWidth - pitch) / pitch), 1);
        var amount = dir * perStep * pitch;

        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var target = Math.max(0, Math.min(track.scrollLeft + amount, track.scrollWidth - track.clientWidth));

        if (reduce || typeof track.scrollTo !== 'function') {
          track.scrollLeft = target;
        } else {
          track.scrollTo({ left: target, behavior: 'smooth' });
          // Guvence: yumusak kaydirma herhangi bir sebeple ilerlemezse
          // (animasyon kapali, tarayici kisitlamasi) hedefe aninda git.
          setTimeout(function () {
            if (Math.abs(track.scrollLeft - target) > 4) track.scrollLeft = target;
          }, 400);
        }
        setTimeout(updateThumbArrows, 500);
      }

      if (prevThumbs) prevThumbs.addEventListener('click', function () { scrollThumbs(-1); });
      if (nextThumbs) nextThumbs.addEventListener('click', function () { scrollThumbs(1); });

      track.addEventListener('scroll', updateThumbArrows, { passive: true });
      window.addEventListener('resize', updateThumbArrows);
      updateThumbArrows();
      // Gorseller yuklendikce genislik degisir
      setTimeout(updateThumbArrows, 300);
      setTimeout(updateThumbArrows, 1200);

      /* Fare ile surukleyerek kaydirma */
      var dragging = false, startX = 0, startScroll = 0, moved = 0;

      /*
        `is-dragging` MOUSEDOWN'da eklenmez. Eklendiginde CSS kucuk
        resimlerin pointer-event'lerini kapatiyor; mouseup baska bir
        ogeye dusuyor ve click hic olusmuyordu — yani kucuk resme
        tiklamak calismiyordu. Simdi sinif ancak parmak/fare gercekten
        hareket edince ekleniyor, tiklama ise ayri bayrakla yutuluyor.
      */
      track.addEventListener('mousedown', function (e) {
        dragging = true;
        moved = 0;
        startX = e.pageX;
        startScroll = track.scrollLeft;
      });

      window.addEventListener('mousemove', function (e) {
        if (!dragging) return;
        e.preventDefault();
        var delta = e.pageX - startX;
        moved = Math.abs(delta);
        if (moved > 4) track.classList.add('is-dragging');
        track.scrollLeft = startScroll - delta;
      });

      window.addEventListener('mouseup', function () {
        if (!dragging) return;
        dragging = false;
        // Suruklemeden sonraki tiklamayi yut, yanlislikla gorsel degismesin
        dragSuppressClick = moved > 6;
        track.classList.remove('is-dragging');
        setTimeout(function () { dragSuppressClick = false; }, 0);
        updateThumbArrows();
      });

      track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }
  }

  /* ------------------------------------------------------------
     YILDIZLARA TIKLAYINCA YORUMLARA KAY
     Basligin altindaki rozet, sayfanin altindaki yorum bolumune
     goturur — klasik e-ticaret davranisi.
     ------------------------------------------------------------ */
  /*
    Hedef, uygulama bolumunun icinde duruyor ve id'sini Judge.me
    belirliyor — sabit bir id'ye guvenilemez. Bu yuzden birkac olasi
    secici sirayla denenir ve EKRANDA YER KAPLAYAN ilk eslesme alinir.
    Gizli/sifir yukseklikli bir hedefe kaydirmak "tikliyorum bir sey
    olmuyor" hissi veriyordu.
  */
  function gorunurHedef(seciciler) {
    for (var i = 0; i < seciciler.length; i++) {
      var list = document.querySelectorAll(seciciler[i]);
      for (var j = 0; j < list.length; j++) {
        var el = list[j];
        if (el.offsetParent !== null && el.getBoundingClientRect().height > 4) return el;
      }
    }
    return null;
  }

  var YORUM_SECICILER = ['#judgeme_product_reviews', '.jdgm-review-widget', '.jdgm-rev-widg'];
  /*
    Judge.me'nin soru-cevap modulu tema blogu olarak sunulmuyor;
    yerine SSS bolumu ve icindeki "soru sor" formu var. Baglanti
    once uygulama modulunu arar, bulamazsa SSS bolumune goturur —
    boylece her durumda calisan bir hedefi olur.
  */
  var SORU_SECICILER  = ['#judgeme_product_qa', '.jdgm-ques-ans', '.jdgm-quest-widg', '.jdgm-QandA', '#sss'];

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-scroll-reviews], [data-scroll-qa]');
    if (!link) return;
    var qa = link.hasAttribute('data-scroll-qa');
    var hedef = gorunurHedef(qa ? SORU_SECICILER : YORUM_SECICILER);
    if (!hedef) return;                    // bolum yoksa normal davran
    e.preventDefault();

    var header = document.querySelector('.header');
    var pay = header ? header.getBoundingClientRect().height + 16 : 16;
    var y = hedef.getBoundingClientRect().top + window.pageYOffset - pay;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduce || typeof window.scrollTo !== 'function') {
      window.scrollTo(0, y);
    } else {
      window.scrollTo({ top: y, behavior: 'smooth' });
      // Guvence: yumusak kaydirma ilerlemezse hedefe aninda git
      setTimeout(function () {
        if (Math.abs(window.pageYOffset - y) > 8) window.scrollTo(0, y);
      }, 600);
    }
  });

  /* ------------------------------------------------------------
     SORU & CEVAP BOLUMU — bos kalirsa gizle

     Judge.me modulu icerigi istemci tarafinda dolduruyor. Modul
     kapaliysa ya da urunde hic soru yoksa kutu bos kalir ve
     sayfada basligi olup govdesi olmayan bir bolum gorunur.
     Yukleme sonrasi kontrol edilip bos ise bolum tamamen kaldirilir.
     ------------------------------------------------------------ */
  /*
    Soru-Cevap modulu sayfada yoksa (uygulamada kapaliysa ya da blok
    henuz eklenmediyse) puan satirindaki "Soru-Cevap" baglantisi
    hicbir yere gitmez. Tiklanip bir sey olmamasindansa gorunmesin.
    Judge.me gec yukledigi icin birkac kez kontrol edilir.
  */
  var soruGozcusu = null;

  function denetleSoruBaglantisi() {
    var link = document.querySelector('[data-scroll-qa]');
    if (!link) return;
    var varMi = !!gorunurHedef(SORU_SECICILER);
    link.hidden = !varMi;
    var ayrac = link.previousElementSibling;
    if (ayrac && ayrac.classList.contains('pdp__rating-sep')) ayrac.hidden = !varMi;
    // Bulundu — artik izlemeye gerek yok
    if (varMi && soruGozcusu) { soruGozcusu.disconnect(); soruGozcusu = null; }
  }

  /*
    Zamanlayiciya guvenilmez: Judge.me'nin ne zaman yuklenecegi
    belli degil, sabit araliklar kacirabiliyor. Sayfadaki degisim
    izlenir; modul ne zaman gelirse gelsin baglanti o an acilir.
  */
  denetleSoruBaglantisi();
  if (window.MutationObserver && document.querySelector('[data-scroll-qa]')) {
    soruGozcusu = new MutationObserver(denetleSoruBaglantisi);
    soruGozcusu.observe(document.body, { childList: true, subtree: true });
    // Sinirsiz izleme yapmasin — bir dakika sonra birak
    setTimeout(function () {
      if (soruGozcusu) { soruGozcusu.disconnect(); soruGozcusu = null; }
    }, 60000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', denetleSoruBaglantisi);
  }

  /* ------------------------------------------------------------
     INDIRIM KODU
     Shopify sepet seviyesinde kod uygulayan bir API sunmaz.
     /discount/KOD adresi kodu oturuma yazar, redirect ile geri
     doner ve kod odeme adiminda uygulanir.
     ------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-discount-apply]');
    if (!btn) return;

    var wrap = btn.closest('[data-discount-field]');
    var input = wrap && wrap.querySelector('[data-discount-input]');
    var note = wrap && wrap.querySelector('[data-discount-note]');
    var kod = input ? input.value.trim() : '';

    if (!kod) {
      if (note) {
        note.textContent = 'Önce bir kod yaz.';
        note.classList.add('is-error');
      }
      if (input) input.focus();
      return;
    }

    if (note) {
      note.textContent = 'Kod uygulanıyor…';
      note.classList.remove('is-error');
    }
    btn.disabled = true;

    var geri = window.location.pathname + window.location.search;
    window.location.href = '/discount/' + encodeURIComponent(kod) +
                           '?redirect=' + encodeURIComponent(geri);
  });

  /* ------------------------------------------------------------
     GORSEL BUYUTME (lightbox)
     Ana gorsele tiklaninca acilir; galerideki sirayi bilir,
     ok tuslari ve dokunmatik kaydirma ile gezilir.
     ------------------------------------------------------------ */
  {
    /*
      Ogeler ILK TIKLAMADA aranir, script yuklendiginde degil.
      Boylece theme.js'in sayfadaki konumu (head/defer, body sonu,
      bir uygulamanin sonradan enjekte etmesi) onemli olmaz.
    */
    var lightbox = null;
    var lbImg = null;
    var lbIndex = null;
    var lbSources = [];
    var lbMap = [];   // kucuk resim sirasi -> lightbox sirasi (video = -1)
    var lbCurrent = 0;
    var lastFocus = null;

    function lbInit() {
      if (lightbox) return true;
      lightbox = document.getElementById('ProductLightbox');
      if (!lightbox) return false;
      lbImg = lightbox.querySelector('[data-lightbox-img]');
      lbIndex = lightbox.querySelector('[data-lightbox-index]');

      // Kaynak listesi kucuk resimlerden gelir; tek gorselli urunde ana gorsel.
      var t = document.querySelectorAll('#PDPGallery [data-thumb]');
      if (t.length) {
        Array.prototype.forEach.call(t, function (b) {
          if (b.hasAttribute('data-video')) { lbMap.push(-1); return; }
          lbMap.push(lbSources.length);
          lbSources.push({ src: b.getAttribute('data-img'), alt: b.getAttribute('data-alt') || '' });
        });
      } else {
        var m = document.getElementById('MainProductImage');
        if (m) lbSources.push({ src: m.src, alt: m.alt });
      }
      return true;
    }

    function lbShow(i) {
      if (!lbSources.length) return;
      if (i < 0) i = lbSources.length - 1;
      if (i >= lbSources.length) i = 0;
      lbCurrent = i;
      if (lbImg) {
        lbImg.src = lbSources[i].src;
        lbImg.alt = lbSources[i].alt;
      }
      if (lbIndex) lbIndex.textContent = i + 1;
    }

    function openLightbox(i) {
      lastFocus = document.activeElement;
      lbShow(i);
      lightbox.hidden = false;
      // hidden kaldirildiktan sonra gecis calissin
      requestAnimationFrame(function () { lightbox.classList.add('is-open'); });
      body.classList.add('locked');
      var close = lightbox.querySelector('[data-lightbox-close]');
      if (close) close.focus();
    }

    function closeLightbox() {
      lightbox.classList.remove('is-open');
      body.classList.remove('locked');
      setTimeout(function () { lightbox.hidden = true; }, 220);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-lightbox-open]');
      if (opener) {
        e.preventDefault();
        if (!lbInit()) return;
        // Galerideki aktif kucuk resmi baslangic al
        var active = document.querySelector('#PDPGallery [data-thumb].is-active');
        var ai = active ? parseInt(active.getAttribute('data-index'), 10) || 0 : 0;
        var li = lbMap.length ? lbMap[ai] : ai;
        openLightbox(li > 0 ? li : 0);
        return;
      }
      if (!lightbox || lightbox.hidden) return;
      if (e.target.closest('[data-lightbox-prev]')) { lbShow(lbCurrent - 1); return; }
      if (e.target.closest('[data-lightbox-next]')) { lbShow(lbCurrent + 1); return; }
      // Arka plana veya kapat dugmesine tiklama kapatir; gorsele tiklama kapatmaz
      if (e.target.closest('[data-lightbox-close]') || !e.target.closest('[data-lightbox-img]')) {
        if (lightbox.contains(e.target)) closeLightbox();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (!lightbox || lightbox.hidden) return;
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowLeft') lbShow(lbCurrent - 1);
      if (e.key === 'ArrowRight') lbShow(lbCurrent + 1);
    });

    /* Dokunmatik: yatay kaydirma ile gorsel degistir */
    var tx = 0, ty = 0;
    document.addEventListener('touchstart', function (e) {
      if (!lightbox || lightbox.hidden) return;
      tx = e.touches[0].clientX; ty = e.touches[0].clientY;
    }, { passive: true });
    document.addEventListener('touchend', function (e) {
      if (!lightbox || lightbox.hidden) return;
      var dx = e.changedTouches[0].clientX - tx;
      var dy = e.changedTouches[0].clientY - ty;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) lbShow(lbCurrent + (dx < 0 ? 1 : -1));
    }, { passive: true });
  }

  /* ------------------------------------------------------------
     VIDEO POSTERINE ALT METNI

     Shopify video_tag filtresi <video> icine alt'siz bir poster
     <img> koyuyor; sunucu tarafinda mudahale edilemiyor ve tarayici
     denetimlerinde 'alt eksik' olarak isaretleniyor.

     Poster dekoratiftir (videonun ilk karesi, ayri bilgi tasimaz),
     dolayisiyla dogru deger BOS alt: ekran okuyucular atlar,
     denetimler de eksik saymaz.
     ------------------------------------------------------------ */
  (function () {
    function posterAlt() {
      document.querySelectorAll('video > img:not([alt])').forEach(function (im) {
        im.setAttribute('alt', '');
      });
    }
    posterAlt();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', posterAlt);
    }
    [600, 2000].forEach(function (ms) { setTimeout(posterAlt, ms); });
  })();

  /* ------------------------------------------------------------
     FOTOĞRAFLI YORUMLARI ÖNE AL

     Judge.me sıralama kutusunda "Önce fotoğraflar" seçeneği var
     ama varsayılan "En yeni". Fotoğraflı yorum satın alma kararına
     düz metinden çok daha fazla etki ettiği için, sayfada fotoğraflı
     yorum VARSA sıralama bir kez ona çevriliyor.

     Tek sefer çalışır: müşteri sıralamayı kendisi değiştirirse
     bir daha karışılmaz. Fotoğraflı yorum yoksa hiç dokunulmaz.
     ------------------------------------------------------------ */
  (function () {
    var uygulandi = false;

    function fotografliOneAl() {
      if (uygulandi) return;
      var sel = document.querySelector(".jm-sort-filter__select, .jdgm-sort-dropdown");
      if (!sel || !sel.options || !sel.options.length) return;

      // Sayfada gercekten fotografli yorum var mi
      var medya = document.querySelector(
        ".jdgm-rev__pics, .jm-review__media, [class*='review'] img[src*='judge'], .jdgm-rev-widg img[src*='judgeme']"
      );
      if (!medya) return;

      var hedef = -1;
      for (var i = 0; i < sel.options.length; i++) {
        if (/önce fotoğraf/i.test(sel.options[i].text)) { hedef = i; break; }
      }
      if (hedef === -1 || sel.selectedIndex === hedef) { uygulandi = true; return; }

      sel.selectedIndex = hedef;
      sel.dispatchEvent(new Event("change", { bubbles: true }));
      uygulandi = true;
    }

    fotografliOneAl();
    if (window.MutationObserver) {
      var g = new MutationObserver(function () {
        fotografliOneAl();
        if (uygulandi) g.disconnect();
      });
      g.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { g.disconnect(); }, 20000);
    }
  })();

  /* ------------------------------------------------------------
     URUN SORU & CEVAPLARI
     "Tum sorulari goster" acar, "Soru Sor" SSS bolumundeki
     forma goturup acar.
     ------------------------------------------------------------ */
  document.addEventListener("click", function (e) {

    /* --- tumunu goster --- */
    var daha = e.target.closest("[data-qa-more]");
    if (daha) {
      var izgara = document.querySelector("[data-qa-grid]");
      if (izgara) {
        izgara.querySelectorAll(".qa-card--gizli").forEach(function (k) {
          k.classList.remove("qa-card--gizli");
        });
      }
      daha.hidden = true;
      return;
    }

    /* --- soru sor: SSS formunu ac ve oraya kaydir --- */
    var sor = e.target.closest("[data-qa-ask]");
    if (!sor) return;

    var form = document.querySelector(".faq__item--form");
    if (!form) return;
    form.open = true;

    var header = document.querySelector(".header");
    var pay = header ? header.getBoundingClientRect().height + 16 : 16;
    var y = form.getBoundingClientRect().top + window.pageYOffset - pay;
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (reduce) { window.scrollTo(0, y); } else {
      window.scrollTo({ top: y, behavior: "smooth" });
      setTimeout(function () {
        if (Math.abs(window.pageYOffset - y) > 8) window.scrollTo(0, y);
      }, 600);
    }

    var alan = form.querySelector("textarea");
    if (alan) setTimeout(function () { alan.focus(); }, 700);
  });

  /* ------------------------------------------------------------
     HERO VIDEOSU — geç ve koşullu yükleme

     Ölçüm: video dosyası 3,3 MB (1080p / 7,2 Mbps) ve mobilde
     de tam boy iniyordu; LCP 12,2 saniyeye çıkıyordu.

     Kural:
       · Veri tasarrufu açık -> yüklenmez
       · Yavaş bağlantı (2g/3g) -> yüklenmez
       · Hareket azaltma açık   -> yüklenmez
       · Diğer durumlarda       -> sayfa yüklendikten SONRA başlar

     MOBİL: eskiden 900px altında video hiç yüklenmiyordu, çünkü
     hero'da poster görseli yoktu ve 1080p dosya LCP'ye giriyordu.
     İkisi de değişti — artık poster fetchpriority=high ile basılıyor
     ve kaynak olarak 720p'yi aşmayan mp4 seçiliyor. Video load
     olayından SONRA başladığı için LCP ölçümünün dışında kalıyor;
     bu yüzden mobil kısıtı kaldırıldı.
     ------------------------------------------------------------ */
  (function () {
    var video = document.querySelector(".hero__media video");
    if (!video) return;

    function yuklenmeliMi() {
      /* v121: telefonda video varsayilan olarak yuklenmiyor.
         Olculdu (390 px): video 3.309 KB, sayfanin geri kalani 1.736 KB.
         Sessiz arka plan videosu icin bu maliyet karsiliksiz; poster
         ayni kareyi gosteriyor. Tema ayarindan acilabilir. */
      var mobilIzin = video.getAttribute("data-mobil") === "1";
      if (!mobilIzin && window.innerWidth < 820) return false;

      var b = navigator.connection;
      if (b) {
        if (b.saveData) return false;
        if (/^(slow-2g|2g|3g)$/.test(b.effectiveType || "")) return false;
      }
      // Kullanıcı işletim sisteminde hareketi azaltmayı açtıysa saygı duy
      try {
        if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return false;
      } catch (e) {}
      return true;
    }

    function baslat() {
      if (!yuklenmeliMi()) return;
      // data-src kullanan varyant (harici mp4 linki)
      video.querySelectorAll("source[data-src]").forEach(function (s) {
        if (!s.src) s.src = s.getAttribute("data-src");
      });
      video.preload = "auto";
      video.load();
      var s = video.play();
      if (s && s.catch) s.catch(function () {});
    }

    /* TETIKLEYICI
       Onceden 'load' olayi bekleniyordu. Olculdu: poster 539 ms'de
       hazirdi ama load 955 ms'de geliyordu ve uzerine 600 ms gecikme
       biniyordu -> video 1680 ms'de basliyordu. Yani poster boyandiktan
       sonra 1,1 saniye bos bekleme vardi.

       Artik LCP ogesinin kendisi (poster) beklenip hemen sonra bosta
       kalan ilk anda basliyor. LCP yine etkilenmiyor cunku poster
       zaten boyanmis oluyor. */
    var poster = document.querySelector(".hero__media img");

    /* Olculdu (v92 canlida): poster 553 ms, video 1519 ms -> hala
       966 ms bekleme vardi. Sebep tetikleyici degil, theme.js'in
       kendisinin gec calismasi: script calistiginda poster ZATEN
       hazir oluyor, ama uzerine 400 ms'lik bosta-bekleme biniyordu.
       Poster hazirsa beklemenin anlami yok — LCP coktan bitmis. */
    function planla(hemen) {
      if (hemen) { setTimeout(baslat, 50); return; }
      if (window.requestIdleCallback) requestIdleCallback(baslat, { timeout: 150 });
      else setTimeout(baslat, 100);
    }

    if (poster && !poster.complete) {
      poster.addEventListener("load", function () { planla(false); }, { once: true });
      poster.addEventListener("error", function () { planla(false); }, { once: true });
      // Poster hic gelmezse video sonsuza kadar beklemesin
      setTimeout(function () { planla(false); }, 2500);
    } else {
      planla(true);   // poster zaten hazir, bekleme
    }
  })();


  /* ------------------------------------------------------------
     YAZI ICINDEKI TABLOLAR
     Blog icerigi Shopify tarafindan basiliyor, HTML'e elle
     sarmalayici ekleyemiyoruz. Olculdu: mobilde tablo 407 px,
     kapsayici 343 px -> 64 px tasiyor ve kaydirilamiyor.
     Tasan tablolar burada kaydirilabilir bir kaba aliniyor.
     ------------------------------------------------------------ */
  document.querySelectorAll(".rte table").forEach(function (t) {
    if (t.parentElement && t.parentElement.classList.contains("table-scroll")) return;
    var kap = document.createElement("div");
    kap.className = "table-scroll";
    t.parentNode.insertBefore(kap, t);
    kap.appendChild(t);
  });
  /* ------------------------------------------------------------
     BILEK OLCUSU ARACI

     Bilek cevresine gore onerilen kasa capi araligi. Ayni tablo
     blogdaki "Saat Kasa Capi Nasil Secilir" yazisinda da var;
     ikisi ayni kalmali, yoksa site kendi kendisiyle celisir.
     ------------------------------------------------------------ */
  (function () {
    var kutu = document.querySelector('[data-fit]');
    if (!kutu) return;

    var girdi  = kutu.querySelector('[data-fit-input]');
    var sonuc  = kutu.querySelector('[data-fit-result]');
    var kasa   = parseFloat(kutu.getAttribute('data-case'));
    if (!girdi || !sonuc || !kasa) return;

    // [bilek alt, bilek ust, onerilen kasa alt, onerilen kasa ust]
    var TABLO = [
      [11, 14, 32, 36],
      [14, 15, 34, 38],
      [15, 16, 36, 40],
      [16, 17, 38, 42],
      [17, 18, 40, 44],
      [18, 19, 42, 46],
      [19, 24, 44, 50]
    ];

    function araligiBul(cm) {
      for (var i = 0; i < TABLO.length; i++) {
        if (cm >= TABLO[i][0] && cm < TABLO[i][1]) return TABLO[i];
      }
      return cm < 11 ? TABLO[0] : TABLO[TABLO.length - 1];
    }

    function hesapla() {
      var cm = parseFloat(String(girdi.value).replace(',', '.'));

      if (!cm || cm < 11 || cm > 24) {
        sonuc.hidden = true;
        sonuc.className = 'fit__sonuc';
        return;
      }

      var a = araligiBul(cm);
      var alt = a[2], ust = a[3];
      var metin, durum;

      if (kasa >= alt && kasa <= ust) {
        durum = 'iyi';
        metin = 'Bu saat sana uyar. ' + cm + ' cm bilek için önerilen aralık ' +
                alt + '–' + ust + ' mm; bu model ' + kasa + ' mm.';
      } else if (kasa < alt) {
        durum = 'kucuk';
        metin = 'Bu model bileğinde küçük durabilir. ' + cm + ' cm için önerilen aralık ' +
                alt + '–' + ust + ' mm; bu model ' + kasa + ' mm.';
      } else {
        durum = 'buyuk';
        metin = 'Bu model bileğinde iri durabilir. ' + cm + ' cm için önerilen aralık ' +
                alt + '–' + ust + ' mm; bu model ' + kasa + ' mm.';
      }

      sonuc.textContent = metin;
      sonuc.className = 'fit__sonuc fit__sonuc--' + durum;
      sonuc.hidden = false;
    }

    girdi.addEventListener('input', hesapla);
  })();

  /* ------------------------------------------------------------
     E-POSTA YAKALAMA PENCERESI

     Olculdu: 30 gunde 293 kullanicidan yalnizca 41'i geri geliyor
     (%14). E-posta, bir kez gelen ziyaretciye tekrar ulasmanin
     tek yolu.

     Tetikleyiciler
       Masaustu : cikis niyeti (imlec pencerenin ustunden ayrilinca)
       Mobil    : cikis niyeti yok -> sayfanin %55'i kaydirilinca
       Ikisinde : en erken N saniye (ayardan), erken acilirsa
                  reklam gibi durur ve kapatilir.

     Acilmadigi durumlar
       · Daha once kapatilmis ve sure dolmamissa
       · Daha once kayit olunmussa (180 gun)
       · SEPETTE URUN VARSA — satin alma akisini bolmemek icin
       · Odeme/hesap sayfalarinda
     ------------------------------------------------------------ */
  (function () {
    var pop = document.querySelector('[data-popup]');
    if (!pop) return;

    var ANAHTAR = 'lecadran-popup';
    var gun     = parseInt(pop.getAttribute('data-days'), 10) || 14;
    var bekle   = (parseInt(pop.getAttribute('data-delay'), 10) || 8) * 1000;
    var esik    = parseInt(pop.getAttribute('data-scroll'), 10) || 55;

    var acildi = false;
    var hazir  = false;
    var sonOdak = null;

    function kayitOku() {
      try { return JSON.parse(localStorage.getItem(ANAHTAR) || '{}'); }
      catch (e) { return {}; }
    }
    function kayitYaz(d) {
      try { localStorage.setItem(ANAHTAR, JSON.stringify(d)); } catch (e) {}
    }

    function gosterilebilirMi() {
      var k = kayitOku();
      if (k.kayitli) return false;
      if (k.kapatildi && Date.now() < k.kapatildi + gun * 864e5) return false;
      // Sepette urun varsa musteriyi bolme
      var sayac = document.getElementById('CartCount');
      if (sayac && parseInt(sayac.textContent, 10) > 0) return false;
      // Odeme ve hesap akisinda hic cikma
      if (/\/(checkout|account|cart)/.test(location.pathname)) return false;
      return true;
    }

    function ac() {
      if (acildi || !hazir || !gosterilebilirMi()) return;
      acildi = true;
      sonOdak = document.activeElement;
      pop.hidden = false;
      // Gecisin baslangic degerini sabitlemek icin ZORUNLU reflow.
      // Onceden requestAnimationFrame kullaniliyordu; kare uretilmeyen
      // durumlarda (arka plan sekmesi, azaltilmis hareket) sinif hic
      // eklenmiyor ve pencere hidden=false olmasina ragmen opacity:0
      // kalip GORUNMEZ oluyordu. Testte yakalandi.
      void pop.offsetWidth;
      pop.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var ilk = pop.querySelector('input[type="email"]');
      if (ilk) setTimeout(function () { ilk.focus(); }, 220);
      temizle();
    }

    function kapat(kaydet) {
      pop.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(function () { pop.hidden = true; }, 260);
      if (kaydet !== false) {
        var k = kayitOku(); k.kapatildi = Date.now(); kayitYaz(k);
      }
      if (sonOdak && sonOdak.focus) sonOdak.focus();
    }

    function cikisNiyeti(e) {
      if (e.clientY <= 0) ac();
    }
    function kaydirma() {
      var h = document.documentElement;
      var yuzde = (h.scrollTop + window.innerHeight) / h.scrollHeight * 100;
      if (yuzde >= esik) ac();
    }
    function temizle() {
      document.removeEventListener('mouseout', cikisNiyeti);
      window.removeEventListener('scroll', kaydirma);
    }

    // Kapatma yollari
    pop.querySelectorAll('[data-popup-close]').forEach(function (b) {
      b.addEventListener('click', function () { kapat(); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && acildi) kapat();
      // Odak tuzagi: Tab pencerenin disina cikmasin
      if (e.key === 'Tab' && acildi) {
        var odaklanabilir = pop.querySelectorAll('button, input, a[href]');
        if (!odaklanabilir.length) return;
        var ilk = odaklanabilir[0], son = odaklanabilir[odaklanabilir.length - 1];
        if (e.shiftKey && document.activeElement === ilk) { e.preventDefault(); son.focus(); }
        else if (!e.shiftKey && document.activeElement === son) { e.preventDefault(); ilk.focus(); }
      }
    });

    // Kod kopyalama
    var kodBtn = pop.querySelector('[data-popup-copy]');
    if (kodBtn) {
      kodBtn.addEventListener('click', function () {
        var kod = kodBtn.getAttribute('data-code') || '';
        var em = kodBtn.querySelector('em');
        var bitir = function () {
          if (!em) return;
          var eski = em.textContent;
          em.textContent = 'Kopyalandı';
          setTimeout(function () { em.textContent = eski; }, 1600);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(kod).then(bitir, bitir);
        } else { bitir(); }
      });
    }

    // Shopify formu sayfayi yeniler; donusteki basari mesajini yakala
    var sonucKutu = pop.querySelector('[data-popup-result]');
    var basarili  = pop.querySelector('.pop__ok');
    if (basarili) {
      var k = kayitOku(); k.kayitli = Date.now(); kayitYaz(k);
      pop.hidden = false;
      pop.classList.add('is-open');
      acildi = true;
      if (sonucKutu) sonucKutu.hidden = false;
      var form = pop.querySelector('[data-popup-form] form');
      if (form) form.hidden = true;
    }

    // Tetikleyicileri gecikmeden sonra bagla
    setTimeout(function () {
      if (!gosterilebilirMi()) return;
      hazir = true;
      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        document.addEventListener('mouseout', cikisNiyeti);
      } else {
        window.addEventListener('scroll', kaydirma, { passive: true });
      }
    }, bekle);
  })();

  /* ------------------------------------------------------------
     YORUM FOTOGRAFLARI — bekletmeden yukle

     Judge.me yorum fotograflarini loading="lazy" ile basiyor.
     Widget zaten 1,3 saniye sonra geliyor; ustune bir de kaydirma
     beklemek fotograflarin cok gec gorunmesine yol acyordu.

     Widget DOM'a girdigi anda ilk birkac fotografin lazy bayragi
     kaldiriliyor. Ilk birkac — hepsi degil; yuzlerce yorumlu bir
     sayfada tamamini eager yapmak bu sefer bant genisligini yer.
     ------------------------------------------------------------ */
  (function () {
    var kap = document.querySelector('[id*="judgeme"], .jdgm-widget, .jdgm-review-widget');
    if (!kap) return;

    var ACILACAK = 6;   // ilk 6 fotograf
    var acilan = 0;

    function ac(kok) {
      var gorseller = kok.querySelectorAll
        ? kok.querySelectorAll('.jm-media-grid__image, .jm-media__image, .jdgm-rev__pic-img')
        : [];
      for (var i = 0; i < gorseller.length && acilan < ACILACAK; i++) {
        var g = gorseller[i];
        if (g.dataset.lcAcildi) continue;
        g.dataset.lcAcildi = '1';
        g.setAttribute('loading', 'eager');
        g.setAttribute('fetchpriority', 'high');
        acilan++;
      }
    }

    ac(kap);

    var gozlemci = new MutationObserver(function (kayitlar) {
      for (var i = 0; i < kayitlar.length; i++) {
        var eklenen = kayitlar[i].addedNodes;
        for (var j = 0; j < eklenen.length; j++) {
          if (eklenen[j].nodeType === 1) ac(eklenen[j]);
        }
      }
      if (acilan >= ACILACAK) gozlemci.disconnect();
    });

    gozlemci.observe(kap, { childList: true, subtree: true });

    // Widget hic gelmezse gozlemci sonsuza kadar acik kalmasin
    setTimeout(function () { gozlemci.disconnect(); }, 15000);
  })();

  /* ------------------------------------------------------------
     KOPYA KORUMA
     ------------------------------------------------------------ */
  document.addEventListener('contextmenu', function (e) {
    var t = e.target;
    if (!t) return;
    if (t.closest('.product-card') || t.closest('.hero__media') ||
        (t.tagName === 'IMG' && t.closest('main'))) {
      e.preventDefault();
    }
  });

  document.addEventListener('dragstart', function (e) {
    if (e.target && e.target.tagName === 'IMG') e.preventDefault();
  });

  try {
    console.log('%cLe Cadran', 'color:#b78852;font-family:Georgia,serif;font-size:32px;letter-spacing:0.3em;');
    console.log('%cBu site Le Cadran için özel kodlanmıştır. Kod ve tasarım telif hakkı ile korunmaktadır.', 'color:#767168;font-size:12px;');
  } catch (e) {}

})();


/* ------------------------------------------------------------
   v104 — KATLANIR ALANLAR (urun aciklamasi, altbilgi SEO metni)
   Yalnizca telefonda ve icerik esikten uzunsa katlanir.
   ------------------------------------------------------------ */
(function () {
  var mq = window.matchMedia('(max-width: 720px)');
  document.querySelectorAll('[data-katla]').forEach(function (k) {
    var icerik = k.querySelector('[data-katla-icerik]');
    var btn = k.querySelector('[data-katla-ac]');
    if (!icerik || !btn) return;
    var esik = parseInt(k.getAttribute('data-katla'), 10) || 380;
    function kur() {
      k.style.setProperty('--katla-h', esik + 'px');
      /* Eski esik (esik + 120) kisa metinlerde de dugme
         cikariyordu: ana sayfadaki 540 karakterlik metin 202 px
         gorunup 379 px'e aciliyordu, yani "devamini oku" 4 satir
         ekliyordu ve anlamsiz duruyordu. Artik gizlenen kisim
         kayda deger olmali. */
      var uzun = icerik.scrollHeight > esik + 260 && icerik.scrollHeight > 420;
      if (mq.matches && uzun && !k.classList.contains('is-acik')) {
        k.classList.add('is-katli');
        btn.hidden = false;
      } else if (!mq.matches) {
        k.classList.remove('is-katli');
        btn.hidden = true;
      }
    }
    btn.addEventListener('click', function () {
      var acik = k.classList.toggle('is-acik');
      k.classList.toggle('is-katli', !acik);
      btn.textContent = acik ? (btn.getAttribute('data-kapa') || 'Daha az göster') : (btn.getAttribute('data-ac') || 'Devamını oku');
      btn.setAttribute('aria-expanded', acik ? 'true' : 'false');
      if (!acik) k.scrollIntoView({ block: 'nearest' });
    });
    kur();
    if (mq.addEventListener) mq.addEventListener('change', kur);
  });
})();

/* ------------------------------------------------------------
   v105 — KAYDIRMA GOSTERGESI
   Telefonda yana kayan listelerin (urunler, kategori kartlari,
   yazilar) altina ne kadar kaydirildigini gosteren ince cizgi.
   ------------------------------------------------------------ */
(function () {
  var sec = ['#shopify-section-featuredcollection .product-grid', '.bento__grid', '.journal__grid'];
  sec.forEach(function (s) {
    var el = document.querySelector(s);
    if (!el) return;
    var cubuk = document.createElement('div');
    cubuk.className = 'kaydir-cubuk';
    cubuk.setAttribute('aria-hidden', 'true');
    var ic = document.createElement('span');
    cubuk.appendChild(ic);
    el.parentNode.insertBefore(cubuk, el.nextSibling);
    function guncelle() {
      var toplam = el.scrollWidth - el.clientWidth;
      if (toplam <= 4) { cubuk.style.visibility = 'hidden'; return; }
      cubuk.style.visibility = '';
      var oran = el.clientWidth / el.scrollWidth;
      ic.style.width = Math.max(oran * 100, 18) + '%';
      var kalan = 100 - Math.max(oran * 100, 18);
      ic.style.transform = 'translateX(' + (el.scrollLeft / toplam) * (kalan / Math.max(oran * 100, 18)) * 100 + '%)';
    }
    el.addEventListener('scroll', guncelle, { passive: true });
    window.addEventListener('resize', guncelle);
    guncelle();
  });
})();


/* ============================================================
   v109 — TESLIM TARIHI
   "3 is gunu icinde teslimat" soyut; hediye alan icin en buyuk
   endise "yetisir mi". Bugunden itibaren is gunu sayip tarih
   yaziyoruz. Saat 16:00'dan sonra bir gun kayar.
   ============================================================ */
(function () {
  var hedef = document.querySelector("[data-teslim]");
  if (!hedef) return;

  var AY = ["Ocak","Şubat","Mart","Nisan","Mayıs","Haziran","Temmuz","Ağustos","Eylül","Ekim","Kasım","Aralık"];
  var GUN = ["Pazar","Pazartesi","Salı","Çarşamba","Perşembe","Cuma","Cumartesi"];

  function isGunuEkle(tarih, adet) {
    var t = new Date(tarih.getTime());
    while (adet > 0) {
      t.setDate(t.getDate() + 1);
      var g = t.getDay();
      if (g !== 0 && g !== 6) adet--;
    }
    return t;
  }

  var simdi = new Date();
  var baslangic = new Date(simdi.getTime());
  var gecKaldi = simdi.getHours() >= 16;
  if (gecKaldi) baslangic.setDate(baslangic.getDate() + 1);

  var erken = isGunuEkle(baslangic, 2);
  var gec = isGunuEkle(baslangic, 4);

  function yaz(t) { return t.getDate() + " " + AY[t.getMonth()]; }

  var baslikEl = document.querySelector("[data-teslim-baslik]");
  if (baslikEl) baslikEl.textContent = "Tahmini teslim";

  var metin = yaz(erken) + " – " + yaz(gec) + " " + GUN[gec.getDay()];
  if (!gecKaldi) {
    metin += " · bugün 16:00'ya kadar sipariş verirsen";
  }
  hedef.textContent = "· " + metin;
})();


/* ============================================================
   v112 — GORSEL BUYUTME EKLERI
   ============================================================ */

/* Buyutulmus urun gorselinde cift dokunus / cift tiklama ile yakinlastirma.
   Telefonda parmakla yakinlastirmak katmanin icinde her zaman calismiyor;
   cift dokunus kesin sonuc veriyor. */
(function () {
  document.addEventListener("click", function (e) {
    var img = e.target.closest("[data-lightbox-img]");
    if (!img) return;
    if (img.dataset.sonTik && Date.now() - Number(img.dataset.sonTik) < 320) {
      img.classList.toggle("is-zoom");
      img.dataset.sonTik = "";
      return;
    }
    img.dataset.sonTik = String(Date.now());
  });
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-lightbox-close]")) {
      var img = document.querySelector("[data-lightbox-img]");
      if (img) img.classList.remove("is-zoom");
    }
  });
})();

/* Urun sayfasi disindaki fotograflar icin basit buyutme katmani.
   Ana sayfadaki musteri fotograflari tiklaninca acilmiyordu. */
(function () {
  var katman = null, resim = null, kapatmaZamani = null;

  function kur() {
    if (katman) return;
    katman = document.createElement("div");
    katman.className = "foto-katman";
    katman.hidden = true;
    katman.innerHTML =
      '<button type="button" class="foto-katman__kapat" aria-label="Kapat">&times;</button>' +
      '<img alt="">';
    resim = katman.querySelector("img");
    document.body.appendChild(katman);
    katman.addEventListener("click", function (e) {
      if (e.target === resim) return;
      kapat();
    });
  }

  function ac(src, alt) {
    kur();
    // Onceki kapanis zamanlayicisi acik katmana hidden yazmasin.
    if (kapatmaZamani) { clearTimeout(kapatmaZamani); kapatmaZamani = null; }
    resim.src = src;
    resim.alt = alt || "";
    katman.hidden = false;
    document.body.style.overflow = "hidden";
    requestAnimationFrame(function () { katman.classList.add("is-open"); });
  }

  function kapat() {
    if (!katman) return;
    katman.classList.remove("is-open");
    document.body.style.overflow = "";
    kapatmaZamani = setTimeout(function () {
      katman.hidden = true;
      kapatmaZamani = null;
    }, 200);
  }

  document.addEventListener("click", function (e) {
    var d = e.target.closest("[data-foto-buyut]");
    if (!d) return;
    var img = d.querySelector("img");
    if (!img) return;
    e.preventDefault();
    ac(img.currentSrc || img.src, img.alt);
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") kapat();
  });
})();


/* ============================================================
   URUN SEKMELERI (v132)

   Paneller SUNUCUDA basilmis bolumlerdir; burada yalnizca hazir
   DOM dugumleri tasiniyor. Icerik hicbir zaman JS ile URETILMIYOR,
   boylece Google ve yapay zeka asistanlari her seyi goruyor.
   Bu dosya hic calismazsa bolumler alt alta kalir, icerik kaybolmaz.

   Dugme ve panel ardisik basiliyor; masaustu/telefon farki
   tamamen CSS'te (bkz. .urun-sekme__liste).
   ============================================================ */
(function () {
  var ETIKET = {
    aciklama:   "Ürün Açıklaması",
    ozellikler: "Teknik Özellikler",
    odeme:      "Ödeme Seçenekleri",
    teslimat:   "Teslimat ve İade",
    sss:        "Sıkça Sorulan Sorular"
  };

  function basla() {
    var kutu = document.querySelector("[data-sekmeler]");
    if (!kutu) return;

    var liste = kutu.querySelector(".urun-sekme__liste");
    var sira = (kutu.getAttribute("data-sira") || "").split(",");
    var paneller = [];

    sira.forEach(function (ham) {
      var ad = ham.trim();
      if (!ad) return;
      var kaynak = document.querySelector('[data-tab="' + ad + '"]');
      if (!kaynak) return;

      /* Sekme etiketi zaten basligi soyluyor; bolumun kendi
         basligini tekrar etmek yer israfi ve "Odeme / Odeme
         Secenekleri" gibi tekrarlara yol aciyor.
         Bazi bolumler .kicker, bazilari .eyebrow kullaniyor. */
      var head = kaynak.querySelector(".section-head");
      if (head && head.parentNode) head.parentNode.removeChild(head);
      var ust = kaynak.querySelector(".kicker, .eyebrow");
      if (ust) {
        var h2 = ust.parentNode.querySelector("h2");
        if (h2 && h2.parentNode) h2.parentNode.removeChild(h2);
        ust.parentNode.removeChild(ust);
      }

      var dugme = document.createElement("button");
      dugme.type = "button";
      dugme.className = "urun-sekme__dugme";
      dugme.setAttribute("aria-expanded", "false");
      dugme.innerHTML = '<span>' + (ETIKET[ad] || ad) + '</span>';

      var panel = document.createElement("div");
      panel.className = "urun-sekme__panel";
      panel.id = "sekme-" + ad;
      panel.setAttribute("role", "region");
      panel.hidden = true;
      panel.appendChild(kaynak);

      dugme.setAttribute("aria-controls", panel.id);

      liste.appendChild(dugme);
      liste.appendChild(panel);

      paneller.push({ ad: ad, panel: panel, dugme: dugme });
    });

    if (!paneller.length) return;

    /* Telefonda akordeon, masaustunde sekme. Davranis farki
       yalnizca "acik olana tekrar basinca kapanir mi" sorusunda. */
    var darMi = window.matchMedia("(max-width: 760px)");

    /* Temada html { scroll-behavior: smooth } var; bu yuzden
       window.scrollBy ANIMASYONLU calisiyordu ve capa duzeltmesi
       buyuk farklarda yetismiyordu (olculdu: -2641 px). Duzeltme
       sirasinda kural gecici olarak kapatiliyor; sayfa ici
       baglanti kaydirmalari yumusak kalmaya devam ediyor. */
    function anlikKaydir(miktar) {
      var h = document.documentElement;
      var eski = h.style.scrollBehavior;
      h.style.scrollBehavior = "auto";
      window.scrollBy(0, miktar);
      h.style.scrollBehavior = eski;
    }

    /* Capa geri getirilemiyorsa (sayfanin basina yaklasilmissa
       yukarida yeterli alan yoktur) baslik en azindan ekranin
       ustune alinir. Hicbir durumda kullanici bambaska bir yere
       bakmaz. */
    function capayiKurtar(dugme) {
      var t = dugme.getBoundingClientRect().top;
      if (t < 0 || t > window.innerHeight - 80) {
        anlikKaydir(t - 90);
      }
    }

    function sec(i, kaydir) {
      /* Ustteki panel kapaninca tiklanan baslik ekranin disina
         ciliyordu (olculdu: Teslimat basliginda -2642 px). Once
         basligin ekrandaki konumu aliniyor, degisiklikten sonra
         ayni konuma geri kaydiriliyor. */
      var capa = i >= 0 && paneller[i] ? paneller[i].dugme : null;
      var capaOnce = capa ? capa.getBoundingClientRect().top : 0;

      paneller.forEach(function (x, j) {
        var aktif = i === j;
        x.panel.hidden = !aktif;
        x.dugme.setAttribute("aria-expanded", aktif ? "true" : "false");
        x.dugme.classList.toggle("is-aktif", aktif);
        /* Panel icindeki tembel yuklenen seyler (PayTR taksit
           tablosu) gizliyken gorus alanina hic girmiyor, bu yuzden
           IntersectionObserver tetiklenmiyordu. Panel acilinca
           haber veriliyor. */
        if (aktif) {
          document.dispatchEvent(new CustomEvent("sekme:acildi", { detail: x.panel }));
        }
      });
      if (capa) {
        var fark = capa.getBoundingClientRect().top - capaOnce;
        if (Math.abs(fark) > 1) anlikKaydir(fark);
        capayiKurtar(capa);
      }

      if (kaydir && paneller[i]) {
        var y = paneller[i].dugme.getBoundingClientRect().top + window.pageYOffset - 80;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }

    function kapat(i) {
      var capa = paneller[i].dugme;
      var once = capa.getBoundingClientRect().top;
      paneller[i].panel.hidden = true;
      paneller[i].dugme.setAttribute("aria-expanded", "false");
      paneller[i].dugme.classList.remove("is-aktif");
      var fark = capa.getBoundingClientRect().top - once;
      if (Math.abs(fark) > 1) anlikKaydir(fark);
      capayiKurtar(capa);
    }

    paneller.forEach(function (x, i) {
      x.dugme.addEventListener("click", function () {
        if (x.dugme.classList.contains("is-aktif")) {
          /* Telefonda akordeon kapanabilir. Masaustu sekme
             gorunumunde kapatmak bos alan birakirdi. */
          if (darMi.matches) kapat(i);
          return;
        }
        sec(i, false);
      });
    });

    /* Klavye: sol/sag ok (masaustu sekme gorunumu) */
    liste.addEventListener("keydown", function (e) {
      if (e.key !== "ArrowRight" && e.key !== "ArrowLeft") return;
      var su = -1;
      paneller.forEach(function (x, j) { if (x.dugme === document.activeElement) su = j; });
      if (su < 0) return;
      e.preventDefault();
      var yeni = e.key === "ArrowRight" ? (su + 1) % paneller.length
                                        : (su - 1 + paneller.length) % paneller.length;
      sec(yeni, false);
      paneller[yeni].dugme.focus();
    });

    /* Sayfa ici baglantilar: hedef bir panelin icindeyse once o
       bolumu ac. "Pesin fiyatina 3 taksit" rozetindeki
       #odeme-secenekleri baglantisi boyle calisiyor. */
    function hedefeGit(hash) {
      if (!hash || hash.length < 2) return false;
      var hedef;
      try { hedef = document.querySelector(hash); } catch (err) { return false; }
      if (!hedef) return false;
      for (var i = 0; i < paneller.length; i++) {
        if (paneller[i].panel.contains(hedef)) { sec(i, true); return true; }
      }
      return false;
    }

    document.addEventListener("click", function (e) {
      var a = e.target.closest ? e.target.closest('a[href^="#"]') : null;
      if (!a) return;
      if (hedefeGit(a.getAttribute("href"))) e.preventDefault();
    });

    sec(0, false);
    kutu.hidden = false;
    if (window.location.hash) hedefeGit(window.location.hash);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", basla);
  } else {
    basla();
  }
})();


/* ============================================================
   v139 — YAPAY ZEKA KARSILAMA KUTUSU TELEFONDA KATLANIR

   Olculdu: kutu 119 px, ilk urunu 541 px'e itiyordu ve cerez
   bandiyla birlikte urunun yalnizca 167 pikseli goruntuleniyordu.
   Telefonda sorular katlanmis basliyor.
   ============================================================ */
(function () {
  var dar = window.matchMedia("(max-width: 760px)");
  var ac = document.getElementById("AiAc");
  var sorular = document.getElementById("AiSorular");
  if (!ac || !sorular) return;

  function kur() {
    if (dar.matches) {
      ac.hidden = false;
      if (ac.getAttribute("aria-expanded") !== "true") sorular.hidden = true;
    } else {
      ac.hidden = true;
      sorular.hidden = false;
    }
  }

  ac.addEventListener("click", function () {
    var acik = ac.getAttribute("aria-expanded") === "true";
    ac.setAttribute("aria-expanded", acik ? "false" : "true");
    sorular.hidden = acik;
    ac.textContent = acik ? "Soruları gör" : "Gizle";
  });

  kur();
  if (dar.addEventListener) dar.addEventListener("change", kur);
})();


/* ---------------------------------------------------------------
   KAPIDA ODEME BUTONUNU SATIN ALMA KUTUSUNA TASI

   Porego'nun uygulama blogu sayfa genisliginde ayri bir bolum olarak
   doguyor. Butonu Sepete Ekle satirinin altina, formun icine aliyoruz.
   Blogun sablondaki yeri onemsiz; nereye eklenirse eklensin buton
   buraya gelir.
   --------------------------------------------------------------- */
(function () {
  if (!document.querySelector(".pdp__buy")) return;

  var tasindi = false;

  function tasi() {
    if (tasindi) return true;
    var sarmal = document.querySelector(".depokargo-cod-form-wrapper");
    if (!sarmal) return false;

    // Rozet yoksa dogrudan satin alma satirinin altina koy.
    // Sepete Ekle satirinin TAM ALTI. Taksit rozeti (.pft) bunun
    // altinda kaliyor; odeme secenekleri alt alta okunuyor.
    var hedef = document.querySelector(".pdp__buy") || document.querySelector(".pft");
    if (!hedef) return false;

    // Tasimadan once blogu tutan bos kalacak bolumu gizle.
    var bolum = sarmal.closest(".shopify-section");

    sarmal.classList.add("pdp__kapida");
    hedef.insertAdjacentElement("afterend", sarmal);

    if (bolum && !bolum.querySelector(".depokargo-cod-form-wrapper")) {
      bolum.style.display = "none";
    }

    tasindi = true;
    return true;
  }

  if (tasi()) return;

  var gozlemci = new MutationObserver(function () {
    if (tasi()) gozlemci.disconnect();
  });
  gozlemci.observe(document.body, { childList: true, subtree: true });

  // Buton hic gelmezse gozlemciyi suresiz acik tutma.
  setTimeout(function () { gozlemci.disconnect(); }, 10000);
})();
